import React from "react";
import { Link } from "react-router-dom";
import { Inbox, UserCheck, CheckCircle2, XCircle } from "lucide-react";

// Onglets de navigation entre les statuts de demandes (même esprit que /chatbotadmin).
const TABS = [
  { key: "requestKnowledge", label: "À traiter", to: "/requestKnowledge", Icon: Inbox },
  { key: "assignee", label: "Assignées", to: "/assignee", Icon: UserCheck },
  { key: "termine", label: "Terminées", to: "/requestTermine", Icon: CheckCircle2 },
  { key: "annule", label: "Annulées", to: "/requestAnnule", Icon: XCircle },
];

const KnowledgeMenu = ({ active }) => {
  return (
    <div className="req-tabs">
      {TABS.map(({ key, label, to, Icon }) => (
        <Link
          key={key}
          to={to}
          className={`req-tab ${active === key ? "active" : ""}`}
        >
          <Icon size={16} />
          {label}
        </Link>
      ))}
    </div>
  );
};

export default KnowledgeMenu;
